import { sendEmailProducerCode } from "../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useProdCodeSendEmail = () => {
  return useMutation(sendEmailProducerCode);
};
export default useProdCodeSendEmail;
